"use strict";

require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.charts = void 0;
require("core-js/modules/es.array.reduce.js");
require("core-js/modules/web.dom-collections.iterator.js");
var types = _interopRequireWildcard(require("../types/charts"));
var _constants = require("../../utils/constants");
const _excluded = ["requestData"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const initialState = {
  charts: {
    data: {},
    displayNameIdList: [],
    active: {},
    errors: {}
  },
  paramsByChartId: {},
  activeSelectors: {
    y1AxisSelect: {
      value: "",
      type: null
    },
    y2AxisSelect: {
      value: "",
      type: null
    },
    displayNameId: {
      y1Axis: [],
      y2Axis: []
    }
  },
  activeGroupOfCharts: {}
};
const charts = exports.charts = function charts() {
  var _payload$requestData;
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  let {
    type,
    payload
  } = arguments.length > 1 ? arguments[1] : undefined;
  switch (type) {
    case types.GET_CHART_DATA_SUCCEEDED:
      {
        const {
            requestData: {
              chartId
            }
          } = payload,
          dataByEquipmentType = _objectWithoutProperties(payload, _excluded);
        return _objectSpread(_objectSpread({}, state), {}, {
          charts: _objectSpread(_objectSpread({}, state.charts), {}, {
            data: _objectSpread(_objectSpread({}, state.charts.data), {}, {
              [chartId]: dataByEquipmentType || {}
            })
          }),
          paramsByChartId: _objectSpread(_objectSpread({}, state.paramsByChartId), {}, {
            [chartId]: _objectSpread(_objectSpread({}, state.paramsByChartId[chartId] || _constants.defaultGroupChartParams), {}, {
              inProgress: false
            })
          })
        });
      }
    case types.GET_CHART_DATA_FAILED:
      return _objectSpread(_objectSpread({}, state), {}, {
        charts: _objectSpread(_objectSpread({}, state.charts), {}, {
          errors: _objectSpread(_objectSpread({}, state.charts.errors), {}, {
            [payload === null || payload === void 0 || (_payload$requestData = payload.requestData) === null || _payload$requestData === void 0 ? void 0 : _payload$requestData.chartId]: {
              message: payload === null || payload === void 0 ? void 0 : payload.message,
              code: payload === null || payload === void 0 ? void 0 : payload.code
            }
          })
        })
      });
    case types.SET_ACTIVE_CHART_DATA:
      return _objectSpread(_objectSpread({}, state), {}, {
        charts: _objectSpread(_objectSpread({}, state.charts), {}, {
          active: _objectSpread(_objectSpread({}, state.charts.active), {}, {
            [payload.chartId]: payload.data
          })
        })
      });
    case types.REMOVE_ACTIVE_CHART_DATA:
      return _objectSpread(_objectSpread({}, state), {}, {
        charts: _objectSpread(_objectSpread({}, state.charts), {}, {
          active: {}
        })
      });
    case types.SET_DISPLAY_NAME_ID_LIST:
      return _objectSpread(_objectSpread({}, state), {}, {
        charts: _objectSpread(_objectSpread({}, state.charts), {}, {
          displayNameIdList: _objectSpread(_objectSpread({}, state.charts.displayNameIdList), {}, {
            [payload.chartId]: Object.values(payload.data).reduce((acc, displayNameIdList) => [...acc, ...(displayNameIdList || [])], []) || []
          })
        })
      });
    case types.SET_ACTIVE_CIRCULATION_GROUP:
      return _objectSpread(_objectSpread({}, state), {}, {
        activeGroupOfCharts: _objectSpread(_objectSpread({}, state.activeGroupOfCharts), {}, {
          [payload.chartId]: payload.groupId
        })
      });
    case types.SET_CHART_PARAMS_LIST:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          paramsByChartId: _objectSpread(_objectSpread({}, state.paramsByChartId), {}, {
            [payload.chartId]: _objectSpread(_objectSpread({}, state.paramsByChartId[payload.chartId] || _constants.defaultGroupChartParams), payload.params || {})
          })
        });
      }
    case types.SET_ACTIVE_SELECT:
      {
        var _payload$y1AxisSelect, _payload$y2AxisSelect;
        return _objectSpread(_objectSpread({}, state), {}, {
          activeSelectors: _objectSpread(_objectSpread({}, payload), {}, {
            displayNameId: {
              y1Axis: (_payload$y1AxisSelect = payload.y1AxisSelect) === null || _payload$y1AxisSelect === void 0 || (_payload$y1AxisSelect = _payload$y1AxisSelect.value) === null || _payload$y1AxisSelect === void 0 ? void 0 : _payload$y1AxisSelect.split("."),
              y2Axis: (_payload$y2AxisSelect = payload.y2AxisSelect) === null || _payload$y2AxisSelect === void 0 || (_payload$y2AxisSelect = _payload$y2AxisSelect.value) === null || _payload$y2AxisSelect === void 0 ? void 0 : _payload$y2AxisSelect.split(".")
            }
          })
        });
      }
    case types.RESET_CHARTS:
      {
        return initialState;
      }
    default:
      return state;
  }
};